import { useRef, useState } from "react";
import { Accordion, Button, Flex, Text } from "@chakra-ui/react";
import { useMutation } from "react-query";
import { NewOrderEarSide, useNewOrderStore } from "../../../stores/order.store";
import { createFile } from "../../../mutations/file.mutations";
import type { SavedFile } from "../../../types/files.types";
import FileInlineInput, {
	type FileInlineInputHandler,
} from "../../../components/FileInlineInput";
import { useSimpleToast } from "../../../hooks/toast.hooks";
import { RightEar } from "./EarIcons";
import BrandFullCheckIcon from "../../../components/icons/BrandFullCheckIcon";
import { EarSectionType } from "./EarSectionType";
import { EarSectionForm } from "./EarSectionForm";
import { NewOrderEarprintShippingType } from "../../../stores/order.store";
import { assertIsValidEarprintFileName } from "./earprint_file_name";

export const EarSectionRight = () => {
	const [, setTick] = useState(0);
	const {
		enableEar,
		hasRightEar,
		earprintShippingType,
		setFile,
		rightFile,
		isRework,
		reworkCommand,
		copySide,
	} = useNewOrderStore();
	const { error } = useSimpleToast();
	const { earmold, formIndexes } = useNewOrderStore();
	const inputInlineRef = useRef<FileInlineInputHandler>(null);
	const mutateCreateFile = useMutation(createFile, {
		onSuccess: (data: SavedFile) => {
			setFile(NewOrderEarSide.RIGHT, data);
		},
	});

	return (
		<Flex
			direction="column"
			justifyContent="center"
			border="solid 1px"
			borderColor="gray.200"
			borderTopRadius="xl"
			pt={4}
			pb={hasRightEar ? 0 : 4}
			bgColor={hasRightEar ? "#FEF2F2" : undefined}
		>
			<Flex
				position="relative"
				direction="column"
				gap={4}
				alignItems="center"
				onClick={() => {
					if (reworkCommand === undefined) {
						enableEar(NewOrderEarSide.RIGHT, !hasRightEar);
					} else {
						const reworkCommandDraft = reworkCommand.draft;
						if (reworkCommandDraft?.hasRightEar === true) {
							enableEar(NewOrderEarSide.RIGHT, !hasRightEar);
						}
					}
				}}
			>
				<RightEar />
				Oreille droite
				{hasRightEar && (
					<Flex className="absolute top-2 right-4 flex gap-4 items-center">
						<Text>Déselectionner l'oreille</Text>
						<BrandFullCheckIcon
							w="24px"
							h="24px"
							className="text-brand-600"
							color="text-brand-600"
						/>
					</Flex>
				)}
				{!hasRightEar && (
					<Flex className="absolute top-2 right-4 flex gap-4 items-center">
						<Text>Sélectionner l'oreille</Text>
						<div className="w-6 h-6 rounded-full border! border-gray-200"></div>
					</Flex>
				)}
			</Flex>

			{hasRightEar && (
				<Flex direction="column" gap={8} pt={8}>
					<Flex
						direction="column"
						justifyContent="center"
						alignItems="center"
						gap={4}
					>
						<Button
							backgroundColor="white"
							width="fit-content"
							onClick={() => copySide(NewOrderEarSide.LEFT)}
						>
							Copier les caractéristiques de l'oreille gauche
						</Button>
						{earprintShippingType === NewOrderEarprintShippingType.DIGITAL &&
							isRework() === false && (
								<Flex direction="row" justifyContent="center" px={4} w="80%">
									<FileInlineInput
										ref={inputInlineRef}
										name={"rightFile"}
										accept=".stl"
										fileName={rightFile?.fileName}
										files={
											rightFile
												? [
														{
															id: rightFile.id,
															name: rightFile.fileName,
															size: rightFile.fileSize,
														},
													]
												: undefined
										}
										isUploading={mutateCreateFile.isLoading}
										onReset={() => {
											setFile(NewOrderEarSide.RIGHT, undefined);
											setTick((tick) => tick + 1);
										}}
										onFileChange={(files: File[] | null) => {
											const reset = () => {
												if (inputInlineRef.current) {
													inputInlineRef.current.reset();
												}
												error(
													"Fichier d'empreinte",
													"Le nom du fichier d'empreinte doit se terminer par _R.stl ou -R.stl",
												);
											};

											if (!Array.isArray(files)) return reset();
											if (files.length === 0) return reset();
											const file = files[0];
											if (!assertIsValidEarprintFileName(file.name, "R")) {
												reset();
											} else {
												mutateCreateFile.mutate({
													file,
													fileName: file.name,
												});
											}
										}}
									/>
								</Flex>
							)}
					</Flex>
					<Accordion index={formIndexes} backgroundColor="#F8FAFC">
						<EarSectionType />
						{earmold && (
							<>
								<EarSectionForm side={NewOrderEarSide.RIGHT} />
							</>
						)}
					</Accordion>
				</Flex>
			)}
		</Flex>
	);
};
